/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-06-05 10:57:29
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-22 16:00:31
 */

import { API_PREFIX } from './constant'
import { Request } from './request'

// 列表
export interface EAFUseListParams {
  startTimeStart?: any
  startTimeEnd?: any
  current?: any
  size?: any
  deviceName?:any
  deviceNumber?:any
}

export function getEAFUseList(
  params: EAFUseListParams
): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspdeviceuse/list`,
    method: 'GET',
    params,
  }
}

export interface DetailParams {
  id?: any
  tenantId?: any
}
// 详情
export function getEAFUseDetail(params: DetailParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspdeviceuse/detail`,
    method: 'GET',
    params
  }
}

// 导出
export function getEAFUseExport(
  params: EAFUseListParams
): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspdeviceuse/list/exportexcel`,
    method: 'GET',
    responseType: 'blob',
    params,
  }
}

// 保存编辑
export interface SubmitParams {
  id?: any
  deviceName?: any
  deviceNumber?: any
  operator?: any
  operatorId?:any
  model?:any
  remark?: any
  runningStatus?: any
  startTime?: any
  stopTime?: any
  status?: any
  updateUser?: any
  useLocal?:any
  usePurpose?:any
}

export function getEAFUseSubmit(body: SubmitParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspdeviceuse/submit`,
    method: 'POST',
    body,
  }
}


// 删除
export function getRemove(ids: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspdeviceuse/remove`,
    method: 'GET',
    params: {
      ids,
    },
  }
}
